module.exports = __webpack_public_path__ + "img/Tier Zero_white.090b0ea5.svg";